import { ID } from "common/entities/IEntity";
import { Type, typeOptions } from "common/entities/IMessage";
import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { Input } from "decorator-form";
import { Entity, Field } from "typegraph";
import { User } from "./User";


export interface IMessageParams {
	sort?: string;
	pageSize?: number;
	type?: Type;
	targetGroupIds: any[];
	useUserGroups?:boolean;
}

const typeSelector = ButtonSelect.registerWithOptions(typeOptions);

@Entity({
	one: "message",
	many: "messages",
	create: "messageCreate",
	update: "messageUpdate"
})
export class Message {

		@Field()
		public id: ID;

		@Field()
		@Input({type: InputType.TEXT, title: "Title"})
		public name: string;

		@Field()
		@Input({type: InputType.DATE, title: "Start Date"})
		public startDate: string;

		@Field()
		@Input({type: InputType.TEXTAREA, title: "Summary"})
		public summary?: string;

		@Field()
		public description?: string;

		@Field()
		@Input({type: typeSelector, title: "Type"})
		public type: Type;

		@Field({entity: User})
		public createdBy?: User;

		@Field()
		public createdOn?: string;

		public targetGroupIds?: ID[];

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/Message.ts